"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIToggleGroup = _interopRequireDefault(require("UIComponents/input/UIToggleGroup"));

var SupportSource = _interopRequireWildcard(require("../../../../constants/search/SupportSource"));

var _i18n = require("../../../../utils/i18n");

var _RadioInput = _interopRequireDefault(require("../inputs/RadioInput"));

var ALL = 'ALL';

var supportOrder = _immutable.default.OrderedSet([ALL, SupportSource.HUBSPOT, SupportSource.APP_PARTNER]);

var _getSupportSourceFilterI18nKey = function _getSupportSourceFilterI18nKey(supportSource) {
  switch (supportSource) {
    case ALL:
      return 'appMarketplace.storefront.filters.supportSource.items.all';

    default:
      return (0, _i18n.getSupportSourceFilterI18nKey)(supportSource);
  }
};

var SupportSourceToggleGroup = function SupportSourceToggleGroup(_ref) {
  var _onChange = _ref.onChange,
      value = _ref.value;
  return _react.default.createElement(_UIToggleGroup.default, {
    name: "support-source"
  }, supportOrder.map(function (supportSource) {
    return _react.default.createElement(_RadioInput.default, {
      key: supportSource,
      checked: value ? supportSource === value : supportSource === ALL,
      onChange: function onChange(_ref2) {
        var inputValue = _ref2.target.value;
        return _onChange(inputValue === ALL ? null : inputValue);
      },
      value: supportSource
    }, _react.default.createElement(_FormattedMessage.default, {
      message: _getSupportSourceFilterI18nKey(supportSource)
    }));
  }));
};

SupportSourceToggleGroup.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.oneOf([SupportSource.HUBSPOT, SupportSource.APP_PARTNER])
};
var _default = SupportSourceToggleGroup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/SupportSourceToggleGroup.js
// module id = 728
// module chunks = 209 210 211 212